import React from 'react';
import PropTypes from 'prop-types';
import { useLeagueSettings } from '../../context/LeagueSettingsContext';
import HiddenText from '../HiddenText';
import { formatLine } from '../../utils/lineDataUtils';
import styles from './styles/scheduled.module.css';

const LockClosedIcon = () => (
  <svg className={styles.lockIcon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px">
    <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
  </svg>
);

const getPickLabel = (pickType, game) => {
  if (pickType === 'home') return game.home_team.abbreviation || game.home_team.name;
  if (pickType === 'away') return game.away_team.abbreviation || game.away_team.name;
  return pickType === 'over' ? 'Over' : 'Under';
};

const LockStatusBars = ({ gameLocks, game, userId, weekNumber, hasUserReachedMaxLocks }) => {
  const { canSeeLockers, canSeeLocks } = useLeagueSettings();

  return (
    <div className={styles.lockStatusBars}>
      {gameLocks.map((lock) => {
        const pickLabel = getPickLabel(lock.pickType, game);
        const isUserLock = lock.userId === userId;

        // Determine what to show based on league settings
        // If user has reached max locks, show everything regardless of settings
        const showUsername = isUserLock || canSeeLockers(weekNumber, isUserLock, 0, 1) || hasUserReachedMaxLocks;
        const showPickInfo = canSeeLocks() || hasUserReachedMaxLocks;

        return (
          <div
            key={`${lock.userId}-${lock.pickType}`}
            className={`${styles.lockStatusBar} ${isUserLock ? styles.userLock : styles.otherLock}`}
          >
            <span className={styles.userSection}>
              {showUsername ? (
                lock.username
              ) : (
                <HiddenText
                  type="locker"
                  weekNumber={weekNumber}
                  showTooltip={true}
                />
              )}
            </span>
            <div className={styles.pickSection}>
              {showPickInfo ? (
                <span>{pickLabel} {formatLine(lock.lockLine)}</span>
              ) : (
                <HiddenText
                  type="lock"
                  weekNumber={weekNumber}
                  showTooltip={true}
                />
              )}
              <div className={styles.lockIconWrapper}>
                <LockClosedIcon />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

LockStatusBars.propTypes = {
  gameLocks: PropTypes.arrayOf(PropTypes.shape({
    userId: PropTypes.number.isRequired,
    username: PropTypes.string.isRequired,
    pickType: PropTypes.string.isRequired,
    lockLine: PropTypes.number.isRequired
  })).isRequired,
  game: PropTypes.shape({
    home_team: PropTypes.shape({
      name: PropTypes.string.isRequired
    }).isRequired,
    away_team: PropTypes.shape({
      name: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  userId: PropTypes.number,
  weekNumber: PropTypes.number,
  hasUserReachedMaxLocks: PropTypes.bool
};

export default LockStatusBars;
